// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3zr6C","right":"Footer_right__2eZoz","buttons":"Footer_buttons__1Azug"};